import * as React from "react";

function SvgDashboardBikes(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.605 8.79c-.601 0-1.25.146-1.8.395l-.668-.997a6.38 6.38 0 013.2-.864.732.732 0 00.733-.732V5.127C22.07 2.3 19.77 0 16.943 0h-1.465a.732.732 0 100 1.465h.733V2.93h-2.197a.733.733 0 00-.61.326l-.759 1.139h-6.15l-.367-.552a2.046 2.046 0 00-1.706-.913H.732A.732.732 0 000 3.662a3.668 3.668 0 003.255 3.64l1.001 1.501C1.898 8.878 0 10.808 0 13.183a4.4 4.4 0 004.395 4.395 4.402 4.402 0 004.132-2.93h4.406c.974 0 1.82-.693 2.01-1.648l.104-.519c.27-1.348.971-2.513 1.923-3.404l.62.925a4.408 4.408 0 00-1.38 3.182c0 2.364 1.989 4.394 4.395 4.394A4.4 4.4 0 0025 13.184a4.4 4.4 0 00-4.395-4.395zm-16.21 5.854h2.532a2.943 2.943 0 01-2.532 1.47 2.933 2.933 0 01-2.93-2.93 2.933 2.933 0 012.93-2.93c.325 0 .638.064.94.167l.256.384c.381.573 1.02.914 1.706.914H4.395c-.81 0-1.465.656-1.465 1.465s.655 1.46 1.465 1.46zm16.21 1.47c-1.587 0-2.93-1.334-2.93-2.93 0-.677.238-1.353.753-1.934l1.57 2.341a.731.731 0 101.215-.815l-1.57-2.342c.354-.123.59-.18.962-.18a2.933 2.933 0 012.93 2.93 2.933 2.933 0 01-2.93 2.93z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  );
}

export default SvgDashboardBikes;
